export enum SalesOrderStatus {
  DRAFT = 'DRAFT',
  ADDED_TO_ORDERBOOK = 'ADDED_TO_ORDERBOOK'
}
